import { render, staticRenderFns } from "./TabelaProcessosFechamento.vue?vue&type=template&id=58457d6a"
import script from "./TabelaProcessosFechamento.vue?vue&type=script&lang=js"
export * from "./TabelaProcessosFechamento.vue?vue&type=script&lang=js"
import style0 from "./TabelaProcessosFechamento.vue?vue&type=style&index=0&id=58457d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports